import { useLazyQuery } from '@apollo/client'

import { GetProductModalSubstituteProductsDocument } from '@/graphql/purchase-plus/generated/getProductModalSubstituteProducts.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetProductModalSubstituteProductsProps {
  productId: number
}

export const useGetProductModalSubstituteProducts = ({ productId }: UseGetProductModalSubstituteProductsProps) => {
  const [fetchProductModalSubstituteProducts, { data, networkStatus, error, refetch }] = useLazyQuery(
    GetProductModalSubstituteProductsDocument,
    {
      variables: {
        productId,
      },
      context: {
        uri: PURCHASE_PLUS_GRAPHQL_API,
      },
      notifyOnNetworkStatusChange: true,
    }
  )

  const substituteProducts = data?.product?.substituteProducts?.unpaginated

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    fetchProductModalSubstituteProducts,
    error,
    substituteProducts,
    loadingStates,
    refetch,
  }
}
